import type { DailyRecord, PlayerStats } from "../types.ts";
import { getTodaysPuzzleId } from "./daily.ts";

const STORAGE_KEY = "burnout-stats";

export function loadStats(): PlayerStats {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      if (parsed.version === 1) return parsed;
    }
  } catch {}
  return {
    version: 1,
    streak: 0,
    maxStreak: 0,
    totalPlayed: 0,
    totalStars: 0,
    history: {},
  };
}

export function saveStats(stats: PlayerStats): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(stats));
}

export function recordCompletion(
  stats: PlayerStats,
  record: DailyRecord
): PlayerStats {
  if (stats.history[record.puzzleId]?.completed) return stats;

  const updated: PlayerStats = {
    ...stats,
    history: { ...stats.history, [record.puzzleId]: record },
    totalPlayed: stats.totalPlayed + 1,
    totalStars: stats.totalStars + record.stars,
    streak: stats.streak,
    maxStreak: stats.maxStreak,
  };

  const today = getTodaysPuzzleId();
  if (record.puzzleId === today) {
    const yesterday = getYesterday();
    if (stats.history[yesterday]?.completed) {
      updated.streak = stats.streak + 1;
    } else {
      updated.streak = 1;
    }
    updated.maxStreak = Math.max(updated.maxStreak, updated.streak);
  }

  return updated;
}

function getYesterday(): string {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}
